<template src="./index.html"></template>
<script>
import bus from '../../util/bus';
export default {
	data() {
		return {
			collapse: false,
			items: [],
			routes: {}
		};
	},
	computed: {
		onRoutes(e) {
			return this.$route.path.replace('/', '');
		}
	},
	methods: {
		meautree(userobj) {
			var meau = JSON.parse(localStorage.getItem('MenuPermission'));
			if (meau[meau.length - 1].resCode == 'ConfigurationCenter') {
				delete meau[meau.length - 1].children;
			}
			return meau;
		},
		forchangeMeau() {
			this.collapse = !this.collapse;
			bus.$emit('collapse-content', this.collapse);
		}
	},
	created() {
		this.items = this.meautree();
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
